var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex-row",on:{"click":function($event){$event.stopPropagation();return _vm.handleCopy.apply(null, arguments)}}},[_c('span',{staticClass:"svn-url",attrs:{"title":_vm.displayText}},[_vm._v(_vm._s(_vm.displayText))]),_c('a-icon',{staticClass:"copy-icon",attrs:{"type":"copy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }